type CbType = (...args: any[]) => any;

const mapCb: Map<string, Promise<any>> = new Map();
const getHash = (cb: CbType) => cb.toString().replace(/\s+/g, '');

export const cacheCallback = <T>(cb: CbType): Promise<T> => {
  const hash = getHash(cb);

  if (mapCb.has(hash)) {
    return mapCb.get(hash) as Promise<T>;
  }

  // eslint-disable-next-line no-async-promise-executor
  const p: Promise<T> = new Promise<T>(async (resolve, reject) => {
    try {
      const data = await cb();

      resolve(data);
    } catch (err) {
      reject(err);
    } finally {
      mapCb.delete(hash);
    }
  });

  mapCb.set(hash, p);

  return p;
};
